import { FC } from "react";
import {
  Row,
  Col,
  Typography,
  FormattedMessage,
  ExtendedDescriptions,
  Spin,
} from "components";
import { hooks } from "../../duck";
import { COL_PROPS, ROW_GUTTER } from "consts";
import { TabProps } from "../../types";

const AddressProps: FC<TabProps> = ({ company }) => {
  const {
    ppbItems,
    ppbLoading,
    registeredOfficeItems,
    registeredOfficeLoading,
  } = hooks.useCompanyAddresses(company);

  return (
    <Row gutter={ROW_GUTTER}>
      <Col {...COL_PROPS}>
        <Typography.Title level={4}>
          <FormattedMessage id="company.secondStep.registeredOffice" />
        </Typography.Title>
        <Spin spinning={registeredOfficeLoading}>
          <ExtendedDescriptions items={ppbItems} />
        </Spin>
      </Col>
      <Col {...COL_PROPS}>
        <Typography.Title level={4}>
          <FormattedMessage id="company.secondStep.principalPlaceOfBusiness" />
        </Typography.Title>
        <Spin spinning={ppbLoading}>
          <ExtendedDescriptions items={registeredOfficeItems} />
        </Spin>
      </Col>
    </Row>
  );
};

export default AddressProps;
